module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('w-button', {
    staticClass: "cash-primary-button",
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "plain": _vm.plain,
      "bg-color": _vm.opts.bgColor,
      "sharp": _vm.sharp,
      "disabled": _vm.disabled,
      "font-color": _vm.opts.fontColor
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-777e6790"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/utils/components/primary-button.vue
// module id = 247
// module chunks = 93